import React, { useContext, useEffect, useState } from "react";
import { fetchvehiclesevennestedtable } from "./apiInsights";
import { FilterContext } from "../../context/Filter";
import Vehiclesevenyeartb from "./Vehiclesevenyeartb";

const Vehicltable = ({ data = [] }) => {
    const { superArn: parArn, childArn } = useContext(FilterContext);
    const [vehicleData, setVehicleData] = useState([]);
    const [lobName, setLobName] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;

    // 🔹 Dynamic payload
    const payload = {
        [key]: value,
        ...(lobName ? { lobName } : {}),
    };

    // 🔹 Fetch vehicle details
    const getVehicleTable = async () => {
        try {
            // console.log("🚀 API Payload:", payload);
            const res = await fetchvehiclesevennestedtable(payload);
            setVehicleData(res || []);
            setIsModalOpen(true); // Open modal after data fetch
        } catch (error) {
            console.error("❌ Error fetching vehicle data:", error);
        }
    };

    // 🔹 When lobName changes, fetch table data
    useEffect(() => {
        if (lobName && value) getVehicleTable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lobName]);

    // 🔹 Handle LOB click
    const handleLobClick = (lob) => {
        // console.log("🟦 Clicked LOB:", lob);
        setLobName(lob);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVehicleData([]);
    };

    return (
        <div className="p-4 overflow-x-auto">
            {/* 🔹 Main Table */}
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left border-r border-blue-400">LOB</th>
                        <th className="px-4 py-2 text-left">Count</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr
                            key={i}
                            className={`${i % 2 === 0 ? "bg-white" : "bg-blue-50"} hover:bg-blue-100`}
                        >
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item?.key?.LOBwise_count || "—"}
                            </td>
                            <td
                                className="px-4 py-2 border-t border-blue-200 text-blue-600 font-semibold cursor-pointer hover:underline"
                                onClick={() => handleLobClick(item?.key?.LOBwise_count)}
                            >
                                {item?.doc_count ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* 🔹 Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                    <div className="bg-white w-11/12 md:w-4/5 lg:w-3/4 xl:w-1/2 rounded-lg shadow-lg p-4 relative max-h-[90vh] overflow-y-auto">
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-2xl font-bold"
                        >
                            ×
                        </button>
                        <h3 className="text-lg font-semibold mb-4 text-[#267CB8]">
                            Vehicle Details for {lobName}
                        </h3>

                        <Vehiclesevenyeartb data={vehicleData} lobName={lobName} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Vehicltable;
